// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__XD-ZL","copyright":"footer_copyright__j3Gxx"};